import { Navigate } from "react-router-dom";
import RouteContainer from "@components/core/RouteContainer";
import MasterLayout from "@components/layouts/MasterLayout";
import { lazy } from "react";

const Users = lazy(() => import("@modules/users/Users"));
const Profiles = lazy(() => import("@modules/profiles/Profiles"));

const paths = [
  { path: "/auth/*", element: <Navigate to="/dashboard" /> },
  { path: "/dashboard/*", element: <Profiles /> },
  { path: "/profiles/*", element: <Profiles /> },
  { path: "/users/*", element: <Users /> },
];

export default function PrivateRoutes() {
  return <RouteContainer paths={paths} layout={<MasterLayout />} />;
}
